import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import { useLocation } from "react-router-dom";
import { BASEURL } from "../../constant/api";

const REDIRECT_DELAY_SEC = 5;

const redirectToFailed = (message) => {
  window.location.href = `/payment/response?status=Failed&message=${encodeURIComponent(
    message || "Transaction not Initiated"
  )}`;
};

export default function Checkout() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const orderId = searchParams.get("orderId");
  const amount = searchParams.get("amount");
  const type = searchParams.get("type");
  const debugMode = searchParams.get("debug") === "1";

  const [loading, setLoading] = useState(true);
  const [errorInfo, setErrorInfo] = useState(null);
  const [countdown, setCountdown] = useState(REDIRECT_DELAY_SEC);
  const redirectTimerRef = useRef(null);

  const scheduleRedirect = (message) => {
    if (debugMode) return;

    let remaining = REDIRECT_DELAY_SEC;
    setCountdown(remaining);

    redirectTimerRef.current = setInterval(() => {
      remaining -= 1;
      setCountdown(remaining);
      if (remaining <= 0) {
        clearInterval(redirectTimerRef.current);
        redirectToFailed(message);
      }
    }, 1000);
  };

  const createCharge = async () => {
    const payload = { orderId, amount, type };
    const apiUrl = `${BASEURL.PORT}/payment/create-charge`;

    const shippingFee = searchParams.get("shippingFee");
    const serviceFee = searchParams.get("serviceFee");
    const offerIds =
      searchParams.get("offer_ids") || searchParams.get("offerIds");

    if (shippingFee) payload.shippingFee = shippingFee;
    if (serviceFee) payload.serviceFee = serviceFee;
    if (offerIds) {
      try {
        payload.offer_ids = JSON.parse(offerIds);
      } catch (err) {
        payload.offer_ids = offerIds.split(",").filter(Boolean);
      }
    }

    try {
      const response = await axios.post(apiUrl, payload);
      const data = response?.data;

      if (data?.status) {
        if (type === "tap" && data.data?.transaction?.url) {
          window.location.href = data.data.transaction.url;
          return;
        }
        if (type === "tamara" && data.data?.checkout_url) {
          sessionStorage.setItem("tamara_order_id", data?.data?.order_id);
          window.location.href = data.data.checkout_url;
          return;
        }
      }

      const message = data?.message || "Transaction not Initiated";
      setLoading(false);
      setErrorInfo({
        message,
        apiUrl,
        payload,
        response: data,
      });
      scheduleRedirect(message);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Transaction not Initiated";

      setLoading(false);
      setErrorInfo({
        message,
        apiUrl,
        payload,
        statusCode: error?.response?.status,
        response: error?.response?.data || null,
      });
      scheduleRedirect(message);
    }
  };

  useEffect(() => {
    createCharge();

    return () => {
      if (redirectTimerRef.current) {
        clearInterval(redirectTimerRef.current);
      }
    };
  }, [search]);

  if (loading) {
    return <Loading />;
  }

  if (!errorInfo) {
    return <Loading />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f8f9fa",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "520px",
          width: "100%",
          background: "#fff",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ color: "#c0392b", marginTop: 0 }}>Payment Error</h2>
        <p style={{ fontSize: "16px", lineHeight: 1.5, color: "#333" }}>
          {errorInfo.message}
        </p>

        <div
          style={{
            marginTop: "16px",
            padding: "12px",
            background: "#f4f6f8",
            borderRadius: "8px",
            fontSize: "13px",
            color: "#555",
            wordBreak: "break-word",
          }}
        >
          <div>
            <strong>API:</strong> {errorInfo.apiUrl}
          </div>
          <div>
            <strong>Order:</strong> {orderId}
          </div>
          <div>
            <strong>Amount:</strong> {amount}
          </div>
          <div>
            <strong>Type:</strong> {type}
          </div>
          {errorInfo.statusCode ? (
            <div>
              <strong>Status:</strong> {errorInfo.statusCode}
            </div>
          ) : null}
        </div>

        {debugMode ? (
          <p style={{ marginTop: "16px", color: "#666", fontSize: "14px" }}>
            Debug mode on — auto redirect disabled. Add{" "}
            <code>?debug=1</code> in URL to keep this screen.
          </p>
        ) : (
          <p style={{ marginTop: "16px", color: "#666", fontSize: "14px" }}>
            Returning to app in <strong>{countdown}</strong> seconds...
          </p>
        )}

        <button
          type="button"
          onClick={() => redirectToFailed(errorInfo.message)}
          style={{
            marginTop: "16px",
            width: "100%",
            padding: "12px",
            border: "none",
            borderRadius: "8px",
            background: "#2c3e50",
            color: "#fff",
            fontSize: "15px",
            cursor: "pointer",
          }}
        >
          Return to App Now
        </button>
      </div>
    </div>
  );
}
